import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import SwipeableView from 'react-swipeable-views';
import { ActionSearch } from 'material-ui/svg-icons';
import { IconButton } from 'material-ui';

import { defControllerView } from '../../../utils';
import { sendCommand } from '../../../utils/mobile';
import Screen from '../../../components/Screen';
import { HistoryType, MatchType, LocationType } from '../../../types/router';
import AddFloatingButton from '../../../components/AddFloatingButton';
import { EmptyPage, PageLoader } from '../../../components/PageWrapper';

import ConversationTabs from '../components/ConversationTabs';
import ConversationList from '../components/ConversationList';
import { localize } from '../../../i18n';

const INTERVAL_MIN = 60000;
const TABS = [
  'due_in',
  'checked_in',
  'in_house',
  'due_out',
  'checked_out',
];

class ConversationsView extends PureComponent {
  componentDidMount() {
    const { twilio } = this.props;
    twilio.requestSync();
    this.interval = setInterval(() => twilio.requestSync(), INTERVAL_MIN);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  returnPathname() {
    return this.props.location.pathname;
  }

  navigate(path, rest) {
    const { history } = this.props;
    const pathname = `/access/chat${path}`;
    console.log(`Navigating to ${pathname}`);
    history.push({
      pathname,
      ...rest,
    });
  }

  selectTab(tab) {
    const { twilio } = this.props;
    this.navigate(`/tab/${tab}`);
    twilio.requestSync();
  }

  openNewChatDialog() {
    this.navigate('/new_chat', {
      state: { returnPathname: this.returnPathname() },
    });
  }

  openChatDialog(channel) {
    const { twilio } = this.props;
    twilio.setActiveChannel(channel.reservationId);

    sendCommand('override', {
      override: 'chatMessaging',
      overrideData: { channel },
    });
  }

  render() {
    const {
      twilio,
      data: {
        counters,
        channels,
        isLoading,
        ready,
      },
      match: {
        params: {
          // default tab is due_in
          tab_id: tabId = 'due_in',
        },
      },
    } = this.props;

    const getTabContent = (tab) => {
      const tabChannels = twilio.getChannelsByState(channels, tab);
      const isEmptyTab = tabChannels.length === 0;

      return (
        <div key={tab}>
          { isEmptyTab ? (
            <EmptyPage icon="drafts" offset={100}>
              <span>
                {this.props.t('No active chats')}.
              </span>
            </EmptyPage>
          ) : (
            <ConversationList
              channels={tabChannels}
              onSelect={channel => this.openChatDialog(channel)}
            />
          )}
        </div>
      );
    };

    const getContent = () => (
      <SwipeableView
        index={TABS.indexOf(tabId)}
        onChangeIndex={index => this.selectTab(TABS[index])}
      >
        {TABS.map(tab => getTabContent(tab))}
      </SwipeableView>
    );

    const searchIcon = (
      <IconButton>
        <ActionSearch />
      </IconButton>
    );

    return (
      <Screen
        title={this.props.t('Active Chats')}
        zDepth={0}
        offset={52}
        iconElementRight={searchIcon}
        onRightIconButtonClick={() => this.openNewChatDialog()}
      >
        <Fragment>
          <ConversationTabs
            active={tabId}
            onChange={tab => this.selectTab(tab)}
            counters={counters}
            isLoading={ready && isLoading}
          />

          {ready
            ? getContent()
            : <PageLoader title={this.props.t('Loading chats')} offset={100} />}
        </Fragment>
        <AddFloatingButton onClick={() => this.openNewChatDialog()} />
      </Screen>
    );
  }
}

ConversationsView.propTypes = {
  twilio: PropTypes.shape({}),
  data: PropTypes.shape({
    counters: PropTypes.shape(),
    channels: PropTypes.array,
  }),
  match: MatchType,
  history: HistoryType,
  t: PropTypes.func.isRequired,
  location: LocationType,
};

export default defControllerView('TwilioController', 'twilio')(localize(ConversationsView));



// WEBPACK FOOTER //
// ./src/views/chat/views/Conversations.js